var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-tags-input',{attrs:{"tags":_vm.tags,"placeholder":_vm.allows_crud
        ? `Adicionar ${_vm.$getVisibleNames('mesh.verb', false, 'Verbo')}`
        : '',"disabled":!_vm.allows_crud},on:{"tags-changed":(newTags) => (_vm.tags = newTags),"before-adding-tag":_vm.checkTag,"before-deleting-tag":_vm.deleteTag},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }